var exports = {
  "i": "x936d19a0--5c575d--wrapper",
};

module.exports = exports;
